import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { CustomerProfile, MarketingChannel, MarketingContext } from '@/models';
import { EnrollmentOptions } from '@/services/loyalty/loyalty.service';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';
import { AccountManagementEvent } from '@/services/analytics/events';
import { isAutoSubscribesToMarketingEmail } from '@/helpers/country';

@Component({
  name: 'CmgAccountModalJoinRewards',
})
export default class CmgAccountModalJoinRewards extends Vue {
  isEnrollingInLoyalty = false;

  get medallionFluted(): string {
    return this.$appStore.state.cms.images.logos.medallionRewardShout.default;
  }

  get customer(): CustomerProfile | null {
    return this.$appStore.state.customer.profile;
  }

  get isEnrolledInLoyalty() {
    return this.$services.loyalty.isEnrolledInLoyalty(this.customer);
  }

  mounted() {
    this.$services.analytics.send(new AccountManagementEvent('requestRewardsStart'));
  }

  async onClickJoinLoyalty(event: any) {
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsAccount,
      action: AnalyticsEventAction.JoinRewardsClick,
      label: AnalyticsEventLabel.JoinRewardsClick,
    });
    this.isEnrollingInLoyalty = true;
    this.$services.ui.pushEventTargetAsLastSelectedElement(event);
    try {
      const shouldSubscribeToMarketingEmail = isAutoSubscribesToMarketingEmail(this.customer?.country);
      const hasEmailMarketing = this.$services.customer.hasSubscription(MarketingChannel.Email, MarketingContext.Marketing);
      const enrollmentOptions: EnrollmentOptions = { customer: this.customer, pageTitle: document.title, shouldSubscribeToMarketingEmail };
      
      await this.$services.loyalty.enrollInLoyalty(enrollmentOptions);
      this.$services.analytics.send(new AccountManagementEvent('requestRewardsComplete'));
      this.$services.ui.showOnboardingModal(this.$services.customer, this.customer ?? undefined);

      if (!shouldSubscribeToMarketingEmail && !hasEmailMarketing) {
        this.$services.ui.setModalVisibility('subscribeEmailMarketing', true);
      }
    } catch (e: any) {
      // TODO-uj25zh: handle errors
      this.$services.logger.error('Something went wrong while enrolling in loyalty', { error: e });
    } finally {
      this.isEnrollingInLoyalty = false;
    }
  }
}
